<script>
    import { mapState} from 'vuex'
    export default{
        data(){
            return {

            }
        },
        methods:{
        },
        computed: {
            ...mapState('user/permit', {
                show: 'admin'
            }),
        },
    }
</script>

<template>
    <a v-if="show" class="mag-header-admin" href="/tourclient/admin/admin/" v-show="show" title="Администрирование">
        <i class="mag-icon-nav-menu-setting"></i>
    </a>
</template>

<style lang="scss">
    .mag-header-admin{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        cursor: pointer;
        text-decoration: none;
        font-size: 20px;
    }
</style>
